import { render, staticRenderFns } from "./DisposicionCard.vue?vue&type=template&id=3c1a8684&"
import script from "./DisposicionCard.vue?vue&type=script&lang=js&"
export * from "./DisposicionCard.vue?vue&type=script&lang=js&"
import style0 from "./DisposicionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports